import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "header__inner" }
const _hoisted_2 = { class: "header__title-wrapper" }
const _hoisted_3 = { class: "header__title" }
const _hoisted_4 = {
  key: 2,
  class: "header__subtitle-wrapper"
}
const _hoisted_5 = { class: "header__subtitle" }

import { onBeforeMount, ref } from 'vue'
import type { Raw } from 'vue'

import { HeaderView } from '@/models/header'

import HeaderUserMenu from './UserMenu.vue'
import FirstGuidePopup from '@/app/components/onboarding/FirstGuidePopup.vue'
import StartFreeTrialButton from './StartFreeTrialButton.vue'
import DocsSortButtonMobile from '@/app/components/listing/DocsSortButton.mobile.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Root',
  props: {
    title: {},
    subtitle: {},
    hasDocSort: { type: Boolean, default: false }
  },
  setup(__props: any) {



const view = ref<Raw<HeaderView>>(new HeaderView())

onBeforeMount(async () => {
  await view.value.init()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["header header--mobile", { 'header--ios': view.value.isIOS }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(__props.title), 1)
      ]),
      (__props.hasDocSort)
        ? (_openBlock(), _createBlock(DocsSortButtonMobile, { key: 0 }))
        : _createCommentVNode("", true),
      (view.value.showCtaButtonOnMobile)
        ? (_openBlock(), _createBlock(StartFreeTrialButton, {
            key: 1,
            class: "header__trial-btn",
            view: view.value
          }, null, 8, ["view"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "actions", {}, () => [
        _createVNode(HeaderUserMenu, { view: view.value }, null, 8, ["view"])
      ]),
      (__props.subtitle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("h1", _hoisted_5, _toDisplayString(__props.subtitle), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(FirstGuidePopup),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})